import { observer } from 'mobx-react-lite'
import CompanyInfo from '../CompanyInfo'
import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import clubStore from "../../storage/ClubStore";
import mapStore from '../../storage/MapStore'


const GeneralCompanyInfo = () => {
  const location = useLocation();
  // useEffect(() => {
  //   if (clubStore.teams.length === 0) {
  //     clubStore.getTeams()
  //   }
  //   clubStore.getTrainersForClub()
  // }, [location.pathname])
  
  useEffect(() => {
    mapStore.loadCompanyInfo(clubStore.club.id)
  }, [location.pathname])
  const club = mapStore.companyDetails || {}
  return (
    <CompanyInfo club={club} teams={club.teams} trainers={club.trainers}/>)
}

export default observer(GeneralCompanyInfo)
